module.exports = __webpack_public_path__ + "img/nowork.1b1989c9.png";